import React from "react";
import Slide from "@material-ui/core/Slide";
import { GetApp } from "@material-ui/icons";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import styled from "styled-components";
import _ from "lodash";

import { RightAlignedValue, CenterAlignedValueGray, CenterAlignedValue, DateValue, WhiteBackground, BigText, CenterAlignedLabel, RightAlignedLabel, VerticalSpace, SelectedListItem, UnSelectedListItem, StyledHeaderButton } from "./styles";

export const EXCEL = "EXCEL";

export const PDF = "PDF";

export const dateMask = value => (value ? [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/] : []);

export const autoCorrectedDatePipe = createAutoCorrectedDatePipe("mm/dd/yyyy");

export var Transition = props => <Slide
  direction="up"
  {
    ...props
  }
/>;

export const styles = theme => ({
  underline: {
    "&:before": {
      borderBottom: "1px solid #2196F3"
    },
    "&:after": {
      borderBottom: "1px solid #2196F3"
    },
    "&$focused:after": {
      borderBottom: "1px solid #2196F3"
    },
    "&$error:after": {
      borderBottom: "1px solid red"
    },
    "&&&:hover:not($disabled):not($focused):not($error):before": {
      borderBottom: "1px solid #43A8FF"
    },
    "&$disabled:before": {
      borderBottom: "1px dotted #9E9E9E"
    }
  },
  textFieldLabel: {

  },
  inputField: {

  },
  error: {
    "& input": {
      borderBottom: "1px solid red"
    }
  },
  disabled: {
    "& input": {
      borderBottom: "1px solid #43A8FF"
    }
  },
  focused: {
    "& input": {
      borderBottom: "1px solid #43A8FF"
    }
  }
});

export const BlueBox = ({ value, label }) => (
  <WhiteBackground>
    <BigText>{value}</BigText>
    <CenterAlignedLabel>{label}</CenterAlignedLabel>
  </WhiteBackground>
);
export const PrimaryData = ({ value, label }) => (
  <VerticalSpace>
    <RightAlignedValue>{value}</RightAlignedValue>
    <RightAlignedLabel>{label}</RightAlignedLabel>
  </VerticalSpace>
);
export const PrimaryDataCenter = ({ value, label }) => {
  if (label) {
    return (
      <VerticalSpace>
        <CenterAlignedValue>{value}</CenterAlignedValue>
        <CenterAlignedLabel>{label}</CenterAlignedLabel>
      </VerticalSpace>
    );
  }

  return (
    <VerticalSpace>
      <CenterAlignedValueGray>{value}</CenterAlignedValueGray>
    </VerticalSpace>
  );
};
export const Date = ({ value, label }) => (
  <VerticalSpace>
    <DateValue>{value}</DateValue>
    <CenterAlignedLabel>{label}</CenterAlignedLabel>
  </VerticalSpace>
);

export const ListItemLink = ({ isSelected, item, label, handleClick }) => {
  const children = (<div>{label || "Selection Needed"}</div>);

  return isSelected ?
    (<SelectedListItem onClick={() => handleClick(item)}>{children}</SelectedListItem>) :
    (<UnSelectedListItem onClick={() => handleClick(item)}>{children}</UnSelectedListItem>);
};

export const ExportButton = props => (<StyledHeaderButton variant="contained" onClick={props.exportClick} disableRipple>
  <GetApp />
  <span>{props.label}</span>
                                      </StyledHeaderButton>);
